(function() {
	// PDP
	const buyItNow = document.getElementById('ob-buy-it-now');

	// Modal
	const modal = document.getElementsByClassName('ob-modal-buy-it-now');
	const closeModal = document.getElementById('close__modal');
	const overlay = document.getElementsByClassName('buyItNow__overlay');
	const btnNext = document.getElementsByClassName('ob-modal_content--button');
	const checkboxMessageError = document.getElementById('buyItNow-msg-error');
	const age = document.getElementById('buyItNow-age[age]');
	const productVariant = document.getElementsByClassName('productVariant');
	const productQdt = document.querySelector('.product-form__quantity .quantity-selector__input');
	
	const toggleAtt = (element, att, page) => {
		if (page === 'quick-buy-drawer') {
			const quickBuyDrawer = document.querySelectorAll('.drawer--quick-buy');
			quickBuyDrawer.forEach((el) => {
				el.removeAttribute('open');
			});
		}
		element.toggleAttribute(att);
	};

	const handlePDPClick = () => {
		toggleAtt(modal[0], 'open');
	};

	//Note: Button "Buy it now" from product page
	buyItNow.addEventListener('click', handlePDPClick);

	closeModal.addEventListener('click', () => {
		toggleAtt(modal[0], 'open');
	});

	overlay[0].addEventListener('click', () => {
		toggleAtt(modal[0], 'open');
	});

	const setCookie = () => {
		const date = new Date();
		date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 dias
		document.cookie = 'agePrivacyPolicy=true; expires=' + date + '; path=/';
	};

	const addToCart = (product, qtd) => {
		let formData = {
			items: [
				{
					id: Number(product),
					quantity: Number(qtd),
				},
			],
		};

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formData),
		})
			.then(() => {
				window.location = window.location.origin + '/checkout';
			})
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error('Error', error);
			});
	};

	btnNext[0].addEventListener('click', () => {
		if (age.checked) {
			btnNext[0].setAttribute('disebled', 'disebled');
			btnNext[0].setAttribute('aria-busy', 'true');

			checkboxMessageError.style.display = 'none';
			const id = productVariant[0].value;
			const qtd = productQdt.value; 

			setCookie();
			addToCart(id, qtd);
		} else {
			checkboxMessageError.style.display = 'flex';
		}
	});

	const handleBuyItNow = () => {
		const variantBtn = document.querySelectorAll('.color-swatch__item');
		const age = document.getElementById('buyItNow-age[age]');
		const privacy = document.getElementById('buyItNow-policy[privacy_policy]');
		const buyItNowStoreAvailability = document.getElementById('store-availability__ob-buy-it-now');
	
		const dataAttr = () => {
			if (age) {
				age.onclick = function () {
					const checked = this.checked;
					this.setAttribute('data-gtm-state', checked);
				};
			}
	
			if (privacy) {
				privacy.onclick = function () {
					const checked = this.checked;
					this.setAttribute('data-gtm-state', checked);
				};
			}
		};
	
		//Note: Button "Buy it now" from drawer store availability
		if (buyItNowStoreAvailability) {
			buyItNowStoreAvailability.addEventListener('click', () => {
				const clickCollectDrawer = document.querySelector('.click-collect-drawer');

				if (clickCollectDrawer) { 
					clickCollectDrawer.removeAttribute('open');
				}
				toggleAtt(modal[0], 'open');
			});
		}
	
		const disabledBuyItNow = (parentClassName) => {
			if (parentClassName.includes('is-disabled')) {
				buyItNow.setAttribute('disabled', true);
				buyItNow.classList.add('bitn-disabled');

				if (buyItNowStoreAvailability) {
					buyItNowStoreAvailability.setAttribute('disabled', true);
					buyItNowStoreAvailability.classList.add('bitn-disabled');
				}

			} else {
				buyItNow.removeAttribute('disabled');
				buyItNow.classList.remove('bitn-disabled');
				if (buyItNowStoreAvailability) {
					buyItNowStoreAvailability.removeAttribute('disabled');
					buyItNowStoreAvailability.classList.remove('bitn-disabled');
				}

			}
		};
	
		variantBtn.forEach((el) =>
			el.addEventListener('click', () => {
				disabledBuyItNow(el.parentNode.className);
			})
		);
	
		dataAttr();
	};
	
	document.addEventListener('DOMContentLoaded', () => {
		handleBuyItNow();
	
		const btnMinus = document.getElementById('button-minus');
		const btnPlus = document.getElementById('button-plus');
		const inputQuantity = document.getElementById('input-quantity');

		const verifyIfQuantityIsOne = () => {
			if (inputQuantity.value === '1') {
				btnMinus.classList.add('icon-minus-impossible');
				btnMinus.classList.remove('icon-minus-possible');
			} else {
				btnMinus.classList.remove('icon-minus-impossible');
				btnMinus.classList.add('icon-minus-possible');
			}
		};
	
		btnMinus.addEventListener('click', () => {
			setTimeout(verifyIfQuantityIsOne, 100);
		});
	
		btnPlus.addEventListener('click', () => {
			setTimeout(verifyIfQuantityIsOne, 100);
		});
	
		verifyIfQuantityIsOne();
	
	});

	document.addEventListener('store-pickup:changed', () => {
		handleBuyItNow();
	});	
})();